import React from "react";

export interface LinkProps {
  children: React.ReactNode;
  to: string;
  type?: LinkTypes;
  component?: React.ElementType | string;
  target?: string;
  rel?: string;
}

export enum LinkTypes {
  cta = "cta",
  nav = "nav",
  inherit = "inherit",
}
